export default __webpack_public_path__ + "static/media/api.6531cbd4.svg";